import PropTypes from "prop-types"
import React from "react"
import { Link, withRouter } from "react-router-dom"

import {
    Col
  } from "reactstrap"
//redux
import { useDispatch } from "react-redux"
import { PRODUCT_FAV_COLOR } from "config";

const Notfound = props => {
  const dispatch = useDispatch()

  return <>
    <Col xl="12" sm="12" className="mt-5">
      <div className="page-wrap d-flex flex-row align-items-center mt-5 pt-5">
        <div className="container mt-5">
          <div className="row justify-content-center mt-5">
            <div className="col-md-12 text-center mt-5">
              <span className="display-1 d-block">404</span>
              <div className="mb-4 lead">The page you are looking for was not found.</div>
              <Link to="/" className={`btn btn-link`} style={{color: PRODUCT_FAV_COLOR}}>Back to Home</Link>
            </div>
          </div>
        </div>
      </div>
    </Col>
  </>
}

Notfound.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Notfound)
